exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-icon {\n  margin-top: 2rem; }\n", ""]);

// exports
